import { Spacing, Typography } from '@persona-id/design-tokens';
import { COLORS, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import Select, { Option } from 'design-system/components/Select';

const Selector = styled('div')`
  padding: ${Spacing[2]};
  display: flex;
  justify-content: flex-end;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: ${Spacing[2]};
  padding: ${Spacing[2]};
`;

interface PageSizeOptionProps {
  currentPageSize: number;
  pageSizeOption: number;
}

export const PageSizeOption = styled('div')<PageSizeOptionProps>`
  padding: 0 ${SPACINGS.base}px;
  color: ${COLORS.indigo80};
  cursor: pointer;

  ${({ currentPageSize, pageSizeOption }) => {
    if (currentPageSize === pageSizeOption) {
      return `
        ${Typography.TextMediumBold};
        text-decoration: underline;
      `;
    }
  }};

  &:hover {
    text-decoration: underline;
  }
`;

interface PageSizeSelectorProps {
  pageSize: number;
  pageSizeOptions: number[];
  handlePageSizeClick: (pageSize: number) => void;
}

const PageSizeSelector = ({
  pageSize,
  pageSizeOptions,
  handlePageSizeClick,
}: PageSizeSelectorProps) => {
  // Add pageSize to selector just in case it isn't part of the options so UI doesn't look weird
  const pageSizes = [
    ...pageSizeOptions,
    ...(pageSizeOptions.includes(pageSize) ? [] : [pageSize]),
  ].sort((a, b) => a - b);

  return (
    <Selector data-test='pagination__page-size-selector'>
      <Label>
        Items per page:
        <Select
          value={pageSize.toString()}
          onValueChange={(val) => handlePageSizeClick(Number(val))}
          size='sm'
        >
          {pageSizes.map((size) => (
            <Option key={size} value={size.toString()}>
              {size}
            </Option>
          ))}
        </Select>
      </Label>
    </Selector>
  );
};

export default PageSizeSelector;
